/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{border-radius:50%;width:100px;height:100px;position:relative;background-color:#ebecee;overflow:hidden}.image[_ngcontent-%COMP%], ca-image-loader[_ngcontent-%COMP%]{border-radius:50%}.initials[_ngcontent-%COMP%]{position:absolute;left:0;right:0;bottom:0;top:0;display:flex;justify-content:center;align-items:center;font-size:24px;font-weight:700;text-transform:uppercase}.initials.small[_ngcontent-%COMP%]{font-size:16px}"];
export { styles as styles };
